// extracted by mini-css-extract-plugin
export var notificationHost = "_cn-0";